module.exports = __webpack_public_path__ + "img/c5201809-2.ea79ed2a.jpg";